module.exports = __webpack_public_path__ + "img/5-1.fa0e76c1.svg";